/**
 * Datumsbehandlung.
 *
 * Fachliche Daten (Belegdatum, Leistungsdatum, Faelligkeit) sind reine
 * Kalendertage ohne Uhrzeit und werden als "YYYY-MM-DD" gespeichert. Das
 * vermeidet die Zeitzonenfehler, die entstehen, wenn ein Belegdatum als
 * Zeitstempel abgelegt und beim Lesen in eine andere Zone gerechnet wird.
 *
 * Technische Zeitpunkte (Anlage, Aenderung, Anmeldung) sind dagegen echte
 * Zeitstempel in UTC nach ISO 8601.
 */
export function toIsoDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function today() {
    return toIsoDate(new Date());
}
export function nowTimestamp() {
    return new Date().toISOString();
}
export function parseIsoDate(value) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
}
export function isValidIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const date = parseIsoDate(value);
    return toIsoDate(date) === value;
}
/** "2026-08-14" -> "14.08.2026" */
export function formatDate(value) {
    if (!value)
        return '';
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
}
/** "2026-08-14T09:31:00.000Z" -> "14.08.2026, 11:31" (lokale Zeit) */
export function formatTimestamp(value) {
    if (!value)
        return '';
    return new Date(value).toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
/** Deutsche Eingabe "14.08.2026" oder "14.8.26" -> IsoDate, sonst null. */
export function parseGermanDate(input) {
    const match = input.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})$/);
    if (!match)
        return isValidIsoDate(input.trim()) ? input.trim() : null;
    const [, dayRaw, monthRaw, yearRaw] = match;
    const day = Number(dayRaw);
    const month = Number(monthRaw);
    const year = yearRaw.length === 2 ? 2000 + Number(yearRaw) : Number(yearRaw);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null;
    }
    return toIsoDate(date);
}
export function addDays(value, days) {
    const date = parseIsoDate(value);
    date.setDate(date.getDate() + days);
    return toIsoDate(date);
}
/** Faelligkeitsdatum aus Belegdatum und Zahlungsziel in Tagen. */
export function dueDate(documentDate, netDays) {
    return addDays(documentDate, netDays);
}
/** Tage zwischen zwei Kalendertagen (b - a). */
export function daysBetween(a, b) {
    const millis = parseIsoDate(b).getTime() - parseIsoDate(a).getTime();
    return Math.round(millis / 86_400_000);
}
/** Ist der Beleg ueberfaellig? */
export function isOverdue(due, reference = today()) {
    return daysBetween(due, reference) > 0;
}
//# sourceMappingURL=dates.js.map